import { List, ListItem, IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import CancelIcon from '@mui/icons-material/Cancel';
import { CartProductCard } from '../productCard/cartProductCard';
import { IShoppingCartItemWithService, removeFromCartAsync } from '../../redux/reducers/shoppingCartReducer';
import { RootState } from '../../redux/store';

interface CartServicesProps {
  className?: string;
  cartItems: IShoppingCartItemWithService[];
}

export function CartServicesList(props: CartServicesProps) {
  const dispatch = useAppDispatch();
  const updatingCart: boolean = useAppSelector((state: RootState) => state.shoppingCartState.updatingCart);

  const handleRemove = (serviceId: string) => {
    dispatch(removeFromCartAsync(serviceId));
  };

  return (
    <List className={props.className} sx={{ width: '100%' }}>
      {props.cartItems.map((item) => (
        <ListItem key={item.serviceId} sx={{ overflowX: 'hidden', py: '4px' }}>
          {item.removable && (
            <IconButton
              disabled={updatingCart}
              sx={{
                color: 'error.main',
                position: 'absolute',
                right: '-10px',
                top: '-10px',
              }}
              onClick={() => handleRemove(item.serviceId)}
            >
              <CancelIcon sx={{ height: '33px', width: '33px' }} />
            </IconButton>
          )}
          <CartProductCard item={item} />
        </ListItem>
      ))}
    </List>
  );
}
